import { useCallback, useState } from "react";
import { TCreateDocumentTemplate, TDocumentTemplate } from "../../models";
import {
  associateDocumentTemplate,
  createDocumentTemplate,
  deleteDocumentTemplate,
  updateDocumentTemplate,
} from "../../network";
import { ActionType } from "../../../../models/ActionType";

export const useCreateDocumentTemplate = (
  mode: ActionType,
  appId: string
): [
  TDocumentTemplate | null,
  boolean,
  Error | null,
  (
    data: TCreateDocumentTemplate | TDocumentTemplate | string
  ) => Promise<TDocumentTemplate>
] => {
  const [result, setResult] = useState<TDocumentTemplate | null>(null);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [error, setError] = useState<Error | null>(null);

  const request = useCallback(
    async (data: TCreateDocumentTemplate | TDocumentTemplate | string) => {
      setIsLoading(true);
      setError(null);
      try {
        const response =
          mode === ActionType.EDIT
            ? await updateDocumentTemplate(
                (data as TDocumentTemplate).id,
                data as TCreateDocumentTemplate
              )
            : mode === ActionType.DELETE
            ? await deleteDocumentTemplate(data as string)
            : await createDocumentTemplate(data as TCreateDocumentTemplate);
        if (mode === ActionType.CREATE) {
          await associateDocumentTemplate(appId, response.id);
        }
        setResult(response);
        return response;
      } catch (e) {
        if (e instanceof Error) {
          setError(e);
        } else {
          setError(new Error("Unknown error"));
        }
      } finally {
        setIsLoading(false);
      }
      return {} as TDocumentTemplate;
    },
    [mode, appId]
  );

  return [result, isLoading, error, request];
};
